import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./shared/routing/Routes";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";
import "./index.css";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AppRoutes />
    </HelmetProvider>
  </React.StrictMode>
);
